import type { IntlShape } from 'react-intl';
import { formatScheduleActivityValue } from '@/shared/scheduleActivities';

interface TranslatedDetailRow {
  key: string;
  label: string;
  value: string;
}

export function translateDetailRows(
  intl: IntlShape,
  details: Record<string, unknown> | null | undefined
): TranslatedDetailRow[] {
  if (!details) return [];
  return Object.entries(details).map(([key, value]) => ({
    key,
    label: intl.formatMessage({ id: `schedule.activities.detail.${key}`, defaultMessage: key }),
    value: formatScheduleActivityValue(value),
  }));
}
